import { Dimensions, Platform } from 'react-native';
import { getLanguage } from '../language/i18n';

// 声明 window 类型，用于 Web 平台
declare const window: { innerWidth: number; innerHeight: number } | undefined;

export const getScreenHeight = () => {
	return Dimensions.get('window').height;
};

export const getScreenWidth = () => {
	// 移动平台使用 Dimensions API
	return Dimensions.get('window').width;
};

export function isUrlText(text: string) {
	const urlRegex = /\b(?:https?:\/\/|www\.)[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g;
	return urlRegex.test(text);
}

export function extractUrls1(text: string) {
	if (!text.includes('http') && !text.includes('https') && !text.includes('www')) {
		return [{ isUrl: false, text }];
	}
	// 完整的正则表达式，用于匹配有效的 URL
	const urlRegex = /\b(?:https?:\/\/|www\.)[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g;

	// 分割文本为 URL 和非 URL 部分
	const parts = text.split(urlRegex).filter(Boolean);

	// 匹配所有的 URL
	const urls = text.match(urlRegex) || [];

	const result = [];

	parts.forEach((part, index) => {
		// 在每个非 URL 部分前可能存在一个 URL
		if (index < urls.length) {
			result.push({ isUrl: true, text: urls[index] });
		}
		result.push({ isUrl: false, text: part });
	});

	// 如果最后一个部分是 URL，没有跟随文本，则补充 URL
	if (urls.length > parts.length) {
		result.push({ isUrl: true, text: urls[urls.length - 1] });
	}

	return result;
}

export function extractUrls(text: string): { isUrl: boolean; text: string }[] {
	if (!text.includes('http') && !text.includes('https') && !text.includes('www')) {
		// 如果 text 为空字符串，返回空数组
		if (!text || text.trim().length === 0) {
			return [];
		}
		return [{ isUrl: false, text }];
	}
	// 使用正则表达式匹配URL
	const urlPattern = /(https?:\/\/[^\s"]+|www\.[^\s"]+)/g;

	// 初始化结果数组
	const result: { isUrl: boolean; text: string }[] = [];

	// 使用exec方法在循环中查找所有匹配项
	let match: RegExpExecArray | null;
	let lastIndex = 0;

	while ((match = urlPattern.exec(text)) !== null) {
		// 如果有非URL文本在当前匹配项之前，则将其添加到结果中
		if (match.index > lastIndex) {
			const trimmedText = text.substring(lastIndex, match.index).trim();
			// 只添加非空字符串
			if (trimmedText.length > 0) {
				result.push({ isUrl: false, text: trimmedText });
			}
		}

		// 将找到的URL添加到结果中
		if (match[0] && match[0].length > 0) {
			result.push({ isUrl: true, text: match[0] });
		}

		// 更新lastIndex为当前匹配项的末尾位置
		lastIndex = match.index + match[0].length;
	}

	// 如果字符串末尾有非URL文本，则将其添加到结果中
	if (lastIndex < text.length) {
		const trimmedText = text.substring(lastIndex).trim();
		// 只添加非空字符串
		if (trimmedText.length > 0) {
			result.push({ isUrl: false, text: trimmedText });
		}
	}

	return result;
}

export function splitTextWithURLs(text: string): { isUrl: boolean; text: string }[] {
	const urlPattern = /(https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&//=]*))/g;
	const result: { isUrl: boolean; text: string }[] = [];
	let lastIndex = 0;

	// 匹配所有的URL
	let match;
	while ((match = urlPattern.exec(text)) !== null) {
		// 如果匹配到URL之前有文本，则先添加这段文本
		if (match.index > lastIndex) {
			result.push({ isUrl: false, text: text.slice(lastIndex, match.index) });
		}
		// 添加URL到结果数组
		result.push({ isUrl: true, text: match[0] });
		lastIndex = match.index + match[0].length;
	}

	// 添加最后剩余的文本（如果有的话）
	if (lastIndex < text.length) {
		result.push({ isUrl: false, text: text.slice(lastIndex) });
	}

	return result;
}

export function extractFirstCharacterOrEmoji(str: string) {
	const regexEmoji = /(?:[\u2700-\u27bf]|[\ud800-\udbff][\udc00-\udfff])/gu;

	// 尝试匹配字符串开头的emoji
	const match = str.match(regexEmoji);

	// 如果找到了匹配项（且它确实是字符串的第一个字符），则返回该emoji
	if (match && match.index === 0) {
		return match[0];
	}

	// 如果没有找到匹配的emoji，或者匹配项不是字符串的第一个字符，则返回字符串的第一个字符
	return str.charAt(0);
}
export const getCurLanguageStr = () => {
	let language = getLanguage();
	switch (language.toLowerCase()) {
		case 'zh':
			return 'zh';
		case 'en':
			return 'en';
		case 'es':
			return 'es';
		case 'pt':
			return 'pt';
		case 'vi':
			return 'vi';
		case 'ja':
			return 'ja';
	}
	return language;
};

export function isChineseChar(char: string): boolean {
	const reg = /[\u4e00-\u9fa5]/;
	return reg.test(char);
}

export function isJapaneseChar(char: string): boolean {
	const c = char.charCodeAt(0);
	// 平假名
	if (0x3040 <= c && c <= 0x309f) {
		return true;
	}
	// 片假名
	else if (0x30a0 <= c && c <= 0x30ff) {
		return true;
	}
	// 片假名补充
	else if (0x31f0 <= c && c <= 0x31ff) {
		return true;
	}
	// 片假名音形集扩展
	else if (0x32e0 <= c && c <= 0x32ff) {
		return true;
	}
	// 汉字
	else if (0x3300 <= c && c <= 0x9fff) {
		return true;
	}
	return false;
}

export function isEsCastellano(char: string): boolean {
	const unicodeRange = /[\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff]/;
	return unicodeRange.test(char);
}

function isVietnamese(character: string): boolean {
	const vietnameseRange = {
		start: 0x1ea0, // 越南语扩展区块开始
		end: 0x1ef9, // 越南语扩展区块结束
	};

	const charCode = character.charCodeAt(0);
	return charCode >= vietnameseRange.start && charCode <= vietnameseRange.end;
}

function isBasicCatalanCharacter(char: string): boolean {
	const catalanCharRangeStart = 0x00c0; // 基本拉丁字母表中的上划线字符开始
	const catalanCharRangeEnd = 0x00ff; // 基本拉丁字母表中的上划线字符结束
	const charCode = char.charCodeAt(0);
	return charCode >= catalanCharRangeStart && charCode <= catalanCharRangeEnd;
}

// 校验用户名：只能字母、数字、下划线、短横线，长度 4~20
export const validateUserName = (val: string) => {
	// 只允许字母、数字、下划线、短横线
	const regex = /^[a-zA-Z0-9_-]+$/;

	if (!regex.test(val)) {
		return '用户名只能包含字母、数字、下划线或-';
	}
	if (val.length < 4 || val.length > 20) {
		return '用户名长度必须在4-20位之间';
	}
	return '';
};

// 校验昵称：非空格字符，长度 4~20
export const validateNickName = (val: string) => {
	const regex = /^\S{4,20}$/;
	if (!regex.test(val)) return '昵称只能是4-20位非空格字符';
	return '';
};

// 校验国际手机号：+国家码-手机号，国家码 1~3 位，手机号 6~14 位
// export const validateCPhone = (val: string) => {
//   const regex = /^\+\d{1,3}-\d{6,14}$/;
//   if (!regex.test(val)) return '手机号格式错误，例如 +86-13800138000';
//   return '';
// };
// 校验手机号（6~14 位数字）
export const validateCPhone = (val: string) => {
	const regex = /^\d{6,14}$/;
	if (!regex.test(val)) {
		return '手机号必须是 6~14 位数字';
	}
	return '';
};

// 校验邮箱
export const validateEmail = (val: string) => {
	const regex = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
	if (!regex.test(val)) return '邮箱格式不正确';
	return '';
};

// 预设比例配置
const PRESET_RATIOS = [9.0 / 16.0, 1.0, 3.0 / 4.0, 4.0 / 3.0, 16.0 / 9.0];

// 计算图片显示尺寸（基于屏幕宽度）- 延迟计算避免模块加载时 Dimensions 未初始化
export const getDimensImageSize = (screenWidth: number) => (screenWidth / 375) * 160;

// 查找最接近的预设比例
const findClosestPresetRatio = (currentRatio: number) => {
	if (!currentRatio || currentRatio <= 0) return 1.0; // 默认返回1:1

	let closestRatio = PRESET_RATIOS[0]; // 默认第一个
	let minDifference = Math.abs(currentRatio - closestRatio);

	// 遍历所有预设比例，找到最接近的
	for (let i = 1; i < PRESET_RATIOS.length; i++) {
		const difference = Math.abs(currentRatio - PRESET_RATIOS[i]);
		if (difference < minDifference) {
			minDifference = difference;
			closestRatio = PRESET_RATIOS[i];
		}
	}

	return closestRatio;
};

export const getImageShowSize = (oWidth: number, oHeight: number, screenWidth: number) => {
	let oRatio = oWidth / oHeight;
	let minWidth = 100;
	let maxWidth = getDimensImageSize(screenWidth); //9:16 = h:w

	let minHeight = 100;
	let maxHeight = 200;

	// console.log(`----> oWidth: ${oWidth}  oHeight: ${oHeight}`);
	if (oWidth <= 0 || oHeight <= 0) {
		return { width: maxWidth, height: Math.floor((maxWidth * 9) / 16) };
	}

	let ratio = findClosestPresetRatio(oRatio);
	if (oHeight > oWidth) {
		let height = Math.max(minHeight, Math.min(maxHeight, oHeight));
		let width = Math.floor(height * ratio);
		return { width: width, height: height };
	} else {
		let width = Math.max(minWidth, Math.min(maxWidth, oWidth));
		let height = Math.floor(width / ratio);
		return { width: width, height: height };
	}
};
